module.exports = "/_next/static/images/HeroIndustryStartups@2x-324bfbc232947c29fc627e0750c8a033.png";